import React, { useState, useMemo, useEffect } from 'react';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import Responsive from 'datatables.net-responsive';
import AreaChart from '../components/charts/AreaChart';
import DoughnutChart from '../components/charts/DoughnutChart';
import HeatmapChart from '../components/charts/HeatmapChart';

DataTable.use(DT);
DataTable.use(Responsive);
import VectorMap from '../components/charts/VectorMap';
import MobileFooter from '../components/MobileFooter';


const Dashboard: React.FC = () => {
    const [, setDtApi] = useState<any>(null);

    const options = useMemo(() => ({
        responsive: true,
        pageLength: 6,
        lengthChange: false,
        searching: true,
        dom: 'rtip',
        initComplete: (settings: any) => {
            const api = new DT.Api(settings);
            setDtApi(api);
        }
    }), []);

    const heatmapData = useMemo(() => {
        const xLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const yLabels = ['12am', '2am', '4am', '6am', '8am', '10am', '12pm', '2pm', '4pm', '6pm', '8pm', '10pm'];
        const data = yLabels.map(() =>
            xLabels.map((_, i) => {
                // Creating a peak around mid-day (index 6-7)
                const hourPeak = 80 - Math.abs(6 - i) * 10;
                return Math.max(0, hourPeak + Math.floor(Math.random() * 40));
            })
        );
        return { data, xLabels, yLabels };
    }, []);

    const referralData = [
        {
            name: 'Reddy John',
            location: 'New Jersey, UK',
            image: 'assets/img/adminuiux/user-1.jpg',
            tasks: 5250,
            earnings: '$ 11523',
            status: 'Active',
            statusClass: 'theme-green',
            statusIcon: 'bg-theme-1'
        },
        {
            name: 'Utkarshaa Dev',
            location: 'New Jersey, UK',
            image: 'assets/img/adminuiux/user-6.jpg',
            tasks: 3250,
            earnings: '$ 15545',
            status: 'Active',
            statusClass: 'theme-green',
            statusIcon: 'bg-theme-1'
        },
        {
            name: 'Nil William',
            location: 'London, UK',
            image: 'assets/img/adminuiux/user-2.jpg',
            tasks: 1250,
            earnings: '$ 25545',
            status: 'Inactive',
            statusClass: 'theme-red',
            statusIcon: 'bg-theme-1'
        },
        {
            name: 'Sanya Tandon',
            location: 'Wembley, UK',
            image: 'assets/img/adminuiux/user-8.jpg',
            tasks: 5250,
            earnings: '$ 11523',
            status: 'Away',
            statusClass: 'theme-orange',
            statusIcon: 'bg-theme-1'
        }
    ];

    useEffect(() => {
        const toastLiveExample1 = document.getElementById('liveToast1');
        const toastLiveExample2 = document.getElementById('liveToast2');

        if (toastLiveExample1 && window.bootstrap) {
            const toastBootstrap1 = window.bootstrap.Toast.getOrCreateInstance(toastLiveExample1);
            setTimeout(() => {
                toastBootstrap1.show();
            }, 500);
        }

        if (toastLiveExample2 && window.bootstrap) {
            const toastBootstrap2 = window.bootstrap.Toast.getOrCreateInstance(toastLiveExample2);
            setTimeout(() => {
                toastBootstrap2.show();
            }, 5000);
        }
    }, []);

    return (
        <>

            {/* Page Title */}
            <div className="container py-3">
                <div className="row gx-3 gx-lg-4 align-items-center page-title">
                    <div className="col col-sm">
                        <h6 className="mb-0">My Dashboard</h6>
                        <p className="text-secondary small">This is personal intranet</p>
                    </div>
                    <div className="col-auto ps-0 position-relative">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-expanded="false">
                            <i className="bi bi-funnel"></i>
                        </button>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="container" id="main-content">

                {/* summary blocks */}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-6 col-md-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 gx-lg-4 align-items-center">
                                    <div className="col">
                                        <p className="text-secondary small mb-2">Daily Sales</p>
                                        <h4 className="mb-1">$ 17450.00</h4>
                                        <p className="text-theme-1 small theme-green"><i className="bi bi-caret-up-fill"></i> $ 12%</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-md-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 gx-lg-4 align-items-center">
                                    <div className="col">
                                        <p className="text-secondary small mb-2">Raw Material</p>
                                        <h4 className="mb-1">$ 7450.00</h4>
                                        <p className="text-red text-theme-1 small"><i className="bi bi-caret-up-fill"></i> - $ 250</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-md-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 gx-lg-4 align-items-center">
                                    <div className="col">
                                        <p className="text-secondary small mb-2">Profit Target</p>
                                        <h4 className="mb-1">50.15<small>%</small></h4>
                                        <p className="text-theme-1 small theme-green"><i className="bi bi-caret-up-fill"></i> 8%</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-md-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 gx-lg-4 align-items-center">
                                    <div className="col">
                                        <p className="text-secondary small mb-2">New Customer</p>
                                        <h4 className="mb-1">120</h4>
                                        <p className="text-theme-1 small theme-green"><i className="bi bi-caret-up-fill"></i> 12.25%</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* sales analytics */}
                <div className="card mb-3 mb-lg-4">
                    <div className="card-header">
                        <div className="row gx-3 gx-lg-4 align-items-center">
                            <div className="col">
                                <h6 className="mb-1">Sales Analytics</h6>
                                <p className="text-secondary small">Informations are provided based on complete sales </p>
                            </div>
                            <div className="col-auto">
                                <button className="btn btn-sm btn-theme-1"><i className="bi bi-download"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <AreaChart labels={['1', '2', '3', '4', '5', '7', '8', '9', '10']}
                            datasets={[
                                {
                                    data: [15, 10, 20, 15, 25, 20, 15, 10, 30, 15],
                                    label: 'Income',
                                    color: '#7080db',
                                    fillColor: 'rgba(135, 206, 250, 0.65)',
                                    borderWidth: 2,
                                    pointBackgroundColor: '#7080db',
                                    pointBorderColor: '#ffffff',
                                    pointRadius: 5,
                                    tension: 0.4,
                                    borderColor: '#7080db',
                                },
                            ]}
                            scalesx={true}
                            scalesy={true}
                            height={140} />
                    </div>
                    <div className="card-footer">
                        <div className="row gx-3">
                            <div className="col-6 col-lg-3 mb-3 mb-lg-0">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto">
                                        <div className="avatar avatar-40 rounded bg-theme-1-subtle text-theme-1 theme-cyan">
                                            <i className="bi bi-cart h5"></i>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <p className="small text-secondary mb-1">Total Sales</p>
                                        <h5>7258</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-lg-3 mb-3 mb-lg-0">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto">
                                        <div className="avatar avatar-40 rounded bg-theme-1-subtle text-theme-1 theme-green">
                                            <i className="bi bi-arrow-up-right h5"></i>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <p className="small text-secondary mb-1">Profit</p>
                                        <h5>$ 13.18 k</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-lg-3">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto">
                                        <div className="avatar avatar-40 rounded bg-theme-1-subtle text-theme-1 theme-purple">
                                            <i className="bi bi-coin h5"></i>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <p className="small text-secondary mb-1">Cost</p>
                                        <h5>$ 36.85 k</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-lg-3">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto">
                                        <div className="avatar avatar-40 rounded bg-theme-1-subtle text-theme-1 theme-yellow">
                                            <i className="bi bi-bar-chart h5"></i>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <p className="small text-secondary mb-1">Revenue</p>
                                        <h5>$ 5.00 k</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* traffic and orders  */}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-12 col-lg-6">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3">
                                    <div className="col">
                                        <h6 className="mb-1">Finance Statistics</h6>
                                        <p className="text-secondary small">Income and expense statistic data view</p>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="tab-content">
                                    <div className="tab-pane fade active show" id="tabhome1" role="tabpanel">
                                        <div className="height-180">
                                            <AreaChart labels={['1', '2', '3', '4', '5', '7', '8', '9', '10']}
                                                datasets={[
                                                    {
                                                        data: [15, 10, 20, 15, 25, 20, 15, 10, 30, 15],
                                                        label: 'Income',
                                                        color: '#9370DB',
                                                        fillColor: 'rgba(185, 135, 250, 0.5)',
                                                        borderWidth: 2,
                                                        pointBackgroundColor: '#9370DB',
                                                        pointBorderColor: '#ffffff',
                                                        pointRadius: 5,
                                                        tension: 0,
                                                        borderColor: '#9370DB',
                                                    },
                                                ]}
                                                scalesx={true}
                                                scalesy={true}
                                                height={180} />
                                        </div>
                                    </div>
                                    <div className="tab-pane fade overflow-y-auto height-180" id="tabhome3" role="tabpanel">
                                        <div className="">
                                            <table className="table table-sm mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Product Name</th>
                                                        <th>Quantity</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>001</td>
                                                        <td>Shoes</td>
                                                        <td>520</td>
                                                    </tr>
                                                    <tr>
                                                        <td>002</td>
                                                        <td>Clothing</td>
                                                        <td>1020</td>
                                                    </tr>
                                                    <tr>
                                                        <td>003</td>
                                                        <td>Pipes</td>
                                                        <td>20</td>
                                                    </tr>
                                                    <tr>
                                                        <td>004</td>
                                                        <td>Shoes</td>
                                                        <td>520</td>
                                                    </tr>
                                                    <tr>
                                                        <td>005</td>
                                                        <td>Clothing</td>
                                                        <td>1020</td>
                                                    </tr>
                                                    <tr>
                                                        <td>006</td>
                                                        <td>Pipes</td>
                                                        <td>20</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer pb-0">
                                <ul className="nav nav-tabs nav-fill adminuiux-tabs" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <a className="nav-link active" id="tabhome1-tab" data-bs-toggle="tab" data-bs-target="#tabhome1" role="tab" aria-controls="tabhome1" aria-selected="true">
                                            <h5 className="mb-1">1.45 k</h5>
                                            <p className="text-secondary mb-0 small"><span className="text-theme-1 theme-green">+15%</span><br /> Visitors</p>
                                        </a>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <a className="nav-link" id="tabhome2-tab" data-bs-toggle="tab" data-bs-target="#tabhome1" role="tab" aria-controls="tabhome1" aria-selected="false">
                                            <h5 className="mb-1">150</h5>
                                            <p className="text-secondary mb-0 small"><span className="text-theme-1 theme-green">+20%</span><br /> Orders</p>
                                        </a>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <a className="nav-link" id="tabhome3-tab" data-bs-toggle="tab" data-bs-target="#tabhome3" role="tab" aria-controls="tabhome3" aria-selected="false">
                                            <h5 className="mb-1">121</h5>
                                            <p className="text-secondary mb-0 small"><span className="text-theme-1 theme-green">+5%</span><br /> Delivered</p>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3">
                                    <div className="col">
                                        <h6 className="mb-1">Traffic time</h6>
                                        <p className="text-secondary small">Here is best time for visitors</p>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body text-center">
                                {/* heatmap chart */}
                                <HeatmapChart
                                    className="height-270 w-100 d-block position-relative"
                                    data={heatmapData.data}
                                    xLabels={heatmapData.xLabels}
                                    yLabels={heatmapData.yLabels}
                                    height={270}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3">
                                    <div className="col">
                                        <h6 className="mb-1">210 Orders</h6>
                                        <p className="text-secondary small">New received orders</p>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body pt-2">
                                <div className="width-200 position-relative mx-auto">
                                    <DoughnutChart
                                        labels={['IA', 'NY', 'LA', 'SA', 'SV']}
                                        data={[40, 10, 15, 25, 10]}
                                        colors={['#e5e2ecff', '#3ee782', '#fb38b4ff', '#9c63f7ff', '#2ebeefff']}
                                        cutout="70%"
                                        height={200}
                                    />
                                    <div className="avatar avatar-140 rounded-circle position-absolute top-50 start-50 translate-middle z-index-1">
                                        <div className="w-100 lh-20">
                                            <h5 className="mb-1">2,55.98K</h5>
                                            <p className="text-theme-1 theme-green">18.71 (0.73%)</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto">
                                        <div className="avatar avatar-40 rounded bg-theme-1-subtle text-theme-1">
                                            <i className="bi bi-bag-plus"></i>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <h5 className="mb-0">209</h5>
                                        <p className="text-secondary small">Product available</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* statistic sales */}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-6">
                        <div className="card mb-3 mb-lg-4 overflow-hidden">
                            <div className="card-body p-0">
                                <div className="row gx-0">
                                    <div className="col p-4">
                                        <h6 className="text-theme-1 mb-3">Employees Statistics</h6>
                                        <h2>48514 <small>hrs</small></h2>
                                        <p className="text-secondary">Your employees are worked hard this week and there are 15 people hired.</p>
                                        <p><span className="text-theme-1 theme-green">$ 250</span> <span className="text-secondary">more hours utilized</span></p>
                                    </div>
                                    <div className="col-12 cool-md-auto text-end">
                                        <img src={asset('assets/img/adminuiux/laptopwoman.png')} alt="" className="h-100" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="card mb-3 mb-lg-4 bg-theme-1 overflow-hidden">
                            <div className="card-body p-0">
                                <div className="row no-gutters">
                                    <div className="col p-4">
                                        <h6 className="mb-3">Sales</h6>
                                        <h2>$ 17450.00</h2>
                                        <p className="opacity-75">Total sales made today and sales payment has been released.</p>
                                        <p><span>$ 150</span> <span className="opacity-75">more hours utilized</span></p>
                                    </div>
                                    <div className="col-12 cool-md-auto text-end">
                                        <img src={asset('assets/img/adminuiux/piggybank.png')} alt="" className="h-100" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* user summary */}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center">
                                        <figure className="avatar avatar-90 rounded"><img src={asset('assets/img/adminuiux/user-1.jpg')} alt="" /></figure>
                                    </div>
                                    <div className="col">
                                        <h4>484 <small className="">hrs</small></h4>
                                        <p className="mb-1">Manisha Srivastav</p>
                                        <p className="text-secondary small">Highest Engagement</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center">
                                        <figure className="avatar avatar-90 rounded"><img src={asset('assets/img/adminuiux/user-6.jpg')} alt="" /></figure>
                                    </div>
                                    <div className="col">
                                        <h4 className="">105 <small>Orders</small></h4>
                                        <p className="mb-1">Jainny Goel</p>
                                        <p className="text-secondary small">Highest Orders</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <h6 className="mb-0">Company Growth and Annual report</h6>
                                <p className="text-secondary"><small>Thursday, 10-5-2026</small></p>
                                <div className="row gx-3">
                                    <div className="col">
                                        <span className="avatar avatar-30 rounded bg-theme-1-subtle text-theme-1"><i className="bi bi-calendar-event"></i></span>
                                    </div>
                                    <div className="col-auto">
                                        <figure className="avatar avatar-30 rounded"><img src={asset('assets/img/adminuiux/user-2.jpg')} alt="" /></figure>
                                        <figure className="avatar avatar-30 rounded"><img src={asset('assets/img/adminuiux/user-6.jpg')} alt="" /></figure>
                                        <figure className="avatar avatar-30 rounded"><img src={asset('assets/img/adminuiux/user-7.jpg')} alt="" /></figure>
                                    </div>
                                    <div className="col-auto">
                                        <button className="btn btn-theme btn-sm">Join</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {/* divider card */}
                <div className="card bg-theme-l-gradient mb-3 mb-lg-4">
                    <div className="card-body">
                        <div className="row gx-3 gx-lg-4 align-items-center">
                            <div className="col-12 col-md-auto align-self-center mb-3 mb-md-0">
                                <figure className="avatar avatar-60 rounded"><img src={asset('assets/img/adminuiux/user-9.jpg')} alt="" /></figure>
                            </div>
                            <div className="col-12 col-md mb-3 mb-md-0">
                                <h5 className="mb-1">You have good time to take profit this week</h5>
                                <p className="opacity-75">Celebrate your success with 50% of profit today.</p>
                            </div>
                            <div className="col-12 col-md-auto align-self-center">
                                <button className="btn btn-link text-white">View all Badges</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* event photo music cards */}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-6 col-lg-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3">
                                    <div className="col-auto">
                                        <span className="avatar avatar-40 rounded bg-theme-1-subtle text-theme-1">
                                            <i className="bi bi-calendar-event"></i>
                                        </span>
                                    </div>
                                    <div className="col-auto">
                                        <h6 className="mb-0">Event</h6>
                                        <p className="text-secondary small">Upcoming event</p>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <h6 className="text-theme-1">London Music Fest 2026</h6>
                                <p className="text-secondary mb-4">25-05-2026</p>
                                <p className="">DevUIUX is HTML template based on Bootstrap 5 framework.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <div className="card position-relative bg-theme-1 mb-3 mb-lg-4 overflow-hidden">
                            <div className="w-100 h-100 coverimg position-absolute top-0 start-0">
                                <img src={asset('assets/img/adminuiux/image-2.jpg')} alt="" />
                            </div>
                            <div className="card-header z-index-1 position-relative">
                                <div className="badge text-bg-theme-1">Trending</div>
                            </div>
                            <div className="card-body z-index-1 position-relative height-90">
                            </div>
                            <div className="card-footer z-index-1 position-relative">
                                <h6 className="mb-1">Album: Jonaatha</h6>
                                <p className="">Release: 28-08-2026</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <div className="card position-relative bg-theme-1 mb-3 mb-lg-4 overflow-hidden">
                            <div className="w-100 h-100 coverimg position-absolute top-0 start-0">
                                <img src={asset('assets/img/adminuiux/image-4.jpg')} alt="" />
                            </div>
                            <div className="card-header z-index-1 position-relative">
                                <div className="badge text-bg-theme-1 theme-pink"><i className="bi bi-heart-fill"></i> Favorite</div>
                            </div>
                            <div className="card-body z-index-1 position-relative height-90">
                                <button className='btn btn-lg btn-square btn-theme theme-red rounded-circle position-absolute top-50 start-50 translate-middle z-index-1'><i className="bi bi-play fs-2"></i></button>
                            </div>
                            <div className="card-footer z-index-1 position-relative">
                                <div className="row gx-3">
                                    <div className="col-auto">
                                        <div className="avatar avatar-40">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-music-note-list avatar avatar-30" viewBox="0 0 16 16">
                                                <path d="M12 13c0 1.105-1.12 2-2.5 2S7 14.105 7 13s1.12-2 2.5-2 2.5.895 2.5 2" />
                                                <path d="M12 3v10h-1V3z" />
                                                <path d="M11 2.82a1 1 0 0 1 .804-.98l3-.6A1 1 0 0 1 16 2.22V4l-5 1z" />
                                                <path d="M0 11.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5m0-4A.5.5 0 0 1 .5 7H8a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5m0-4A.5.5 0 0 1 .5 3H8a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <h6 className="mb-1">Album: Jonaatha</h6>
                                        <p className="">Playing Now</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="badge badge-light text-bg-theme-1">Event</div>
                            </div>
                            <div className="card-body">
                                <h6 className="text-theme-1">Tech Event 2026</h6>
                                <p className="text-secondary"><i className="bi bi-calendar-event me-2"></i> 25-05-2026</p>
                                <p className="">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque eget finibus felis, a sagittis magna. </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* popular zone*/}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-6 col-lg-6">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3 gx-lg-4 align-items-center">
                                    <div className="col">
                                        <h6 className="mb-1">Referral Earnings</h6>
                                        <p className="text-secondary small">Top users with highest referral earnings </p>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <DataTable className="table mb-3" options={{ ...options, pageLength: 5, searching: false }}>
                                    <thead>
                                        <tr>
                                            <th>User</th>
                                            <th className="none">Tasks</th>
                                            <th>Earning</th>
                                            <th className="tablet desktop">Status</th>
                                            <th className="tablet desktop">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {referralData.map((user, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div className="row gx-3">
                                                        <div className="col-auto">
                                                            <figure className="avatar avatar-40 rounded">
                                                                <img src={window.asset ? window.asset(user.image) : user.image} alt="" />
                                                            </figure>
                                                        </div>
                                                        <div className="col">
                                                            <h6 className="mb-1">{user.name}</h6>
                                                            <p className="text-secondary small">{user.location}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <h6 className="mb-1">{user.tasks}</h6>
                                                    <p className="text-secondary small">Task</p>
                                                </td>
                                                <td>
                                                    <h6 className="mb-1">{user.earnings}</h6>
                                                    <p className="text-secondary small">Total Earning</p>
                                                </td>
                                                <td><span className={`badge badge-light text-bg-theme-1 ${user.statusClass}`}><span className={`rounded-circle avatar avatar-10 ${user.statusIcon}`}></span> {user.status}</span></td>
                                                <td>
                                                    <button className="btn btn-link btn-sm btn-square me-1"><i className="bi bi-pencil"></i></button>
                                                    <button className="btn btn-sm btn-square btn-link theme-green"><i className="bi bi-telephone"></i></button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </DataTable>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3 gx-lg-4 align-items-center">
                                    <div className="col">
                                        <h6 className="mb-1">Most Popular Zone</h6>
                                        <p className="text-secondary small">Top countires with highest orders </p>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <VectorMap height={140} />
                            </div>
                            <div className="card-footer">
                                <div className="row gx-4">
                                    <div className="col text-end">
                                        <p className="text-secondary mb-1">Daily Sales</p>
                                        <h2 className="font-weight-light mb-1">$1740</h2>
                                        <p className="text-theme-1 theme-green small">+$250</p>
                                    </div>
                                    <div className="col">
                                        <p className="text-secondary mb-1">Raw Material</p>
                                        <h2 className="font-weight-light mb-1">$1750</h2>
                                        <p className="text-theme-1 theme-red small">-$250</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            {/* Toast */}
            <div className="toast-container position-fixed bottom-0 end-0 p-2">
                <div id="liveToast1" className="toast" data-bs-delay="4500" role="alert" aria-live="assertive" aria-atomic="true">
                    <div className="toast-header">
                        <img src={asset('assets/img/favicon.png')} className="rounded me-2" alt="..." />
                        <strong className="me-auto">DevUIUX</strong>
                        <small>10 sec ago</small>
                        <button type="button" className="btn-close" data-bs-dismiss="toast"></button>
                    </div>
                    <div className="toast-body">
                        Hello, Beautiful people from Earth!<br /> Next toast message will appear with good message at the top right.
                    </div>
                </div>
            </div>
            <div className="toast-container position-fixed top-0 end-0 p-2">
                <div id="liveToast2" className="toast" data-bs-delay="3500" role="alert" aria-live="assertive" aria-atomic="true">
                    <div className="toast-header">
                        <img src={asset('assets/img/favicon.png')} className="rounded me-2" alt="..." />
                        <strong className="me-auto">DevUIUX</strong>
                        <small>10 sec ago</small>
                        <button type="button" className="btn-close" data-bs-dismiss="toast"></button>
                    </div>
                    <div className="toast-body">
                        We are here to create amazing things ❤️.<br />Hope. you'll like it and share it.
                    </div>
                </div>
            </div>

            <MobileFooter />
        </>
    );
};

export default Dashboard;
